<template>
  <div style="margin-top: 113px">
    <v-container>
      <v-snackbar
        v-model="snackbar"
        :color="snackBarColor"
        :timeout="snackBarTimeout"
      >
        <b>{{ snackBarText }} </b>
      </v-snackbar>

      <v-card style="display: flex; justify-content:space-between">
        <div style="align-self : flex-start; margin-left:15px; display:flex;">
          <div>
            <v-text-field
              single-line
              hide-details
              v-model="findByName"
              label="Search by fullName"
            ></v-text-field>
            <v-select
              single
              :items="activeSelect"
              v-model="selectedActive"
              label="Search by active"
              style="margin-top: 25px"
              @change="clearData()"
            ></v-select>
          </div>
          <div style="margin-left: 100px">
            <v-select
              single
              :items="topSelect"
              v-model="selectedTop"
              label="Search by top"
              @change="clearData()"
            ></v-select>
            <v-select
              single
              :items="refCountries"
              v-model="selectedCountry"
              item-text="label"
              item-value="code"
              label="Search by Perimeter"
              @change="check(), clearData()"
            ></v-select>
          </div>
        </div>
        <div
          style="text-align: right;align-self : flex-end;margin-right:10px;margin-bottom: 20px"
        >
          <div class="my-2">
            <v-btn
              dark
              color="rgb(0, 99, 91)"
              style="margin-right:10px"
              v-on:click="search"
              >Search</v-btn
            >
          </div>
          <div class="my-2" style="text-align: center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  small
                  class="mx-2"
                  fab
                  dark
                  color="rgb(0, 99, 91)"
                  v-on:click="addNew"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
              <span>Add new user</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  small
                  class="mx-2"
                  fab
                  dark
                  color="rgb(0, 99, 91)"
                  v-on:click="exportAsCsv"
                >
                  <v-icon>mdi-database-export</v-icon>
                </v-btn>
              </template>
              <span>Export data</span>
            </v-tooltip>
          </div>
        </div>
      </v-card>
      <v-card style="margin-top:15px">
        <v-card-text>
          <v-simple-table>
            <template v-slot:default>
              <v-data-table
                :headers="headers"
                :items="listUsers"
                :items-per-page="15"
              >
                <template v-slot:[`item.actions`]="{ item }">
                  <v-btn small icon @click="updateEmployee(item)">
                    <v-icon v-if="setIcon(item)" class="btn-action"
                      >mdi-lead-pencil
                    </v-icon>
                    <v-icon v-else class="btn-action">mdi-file-eye</v-icon>
                  </v-btn>
                </template>
                <template v-slot:[`item.active`]="{ item }">
                  <v-icon v-if="item.active == true" color="green"
                    >mdi-check</v-icon
                  >
                  <v-icon v-else color="red">mdi-close</v-icon>
                </template>
              </v-data-table>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<style>
.margin-top {
  margin-top: 10px;
}

.no-margin {
  margin: 0 !important;
}

.card {
  height: 100vh !important;
}
.btn-action:hover,
.general-background {
  cursor: pointer;
  color: #00695c !important;
}
</style>

<script>
import { mapGetters } from "vuex";

export default {
  name: "AdminUser",
  computed: {
    ...mapGetters({
      user: "auth/user",
      perimeterAdmin: "auth/perimeterAdmin",
      userHasRoleAdmin: "auth/userHasRoleAdmin",
    }),
  },

  data() {
    return {
      headers: [
        { text: "User", value: "fullName" },
        { text: "Active", value: "active" },
        { text: "Strong line manager", value: "slm.fullName" },
        { text: "Dotted line manager", value: "dlm.fullName" },
        { text: "Company", value: "company.code" },
        { text: "Perimeter", value: "workingCountry.label" },
        { text: "Action", value: "actions" },
      ],
      findByName: "",
      selectedActive: "Active",
      selectedTop: "ALL",
      selectedCountry: "all",
      listUsers: [],
      activeSelect: ["Active", "Inactive", "All"],
      topSelect: ["Top", "Not top", "All"],
      refCountries: [],
      result: false,
      snackbar: false,
      snackBarText: "",
      snackBarColor: "",
      snackBarTimeout: 2000,
    };
  },
  mounted: function() {
    if (this.$route.query.add == "ok") {
      this.snackbar = true;
      this.snackBarText = "Saved successfully";
      this.snackBarColor = "success";
      this.$router.push("/adminuser/");
    }
    this.fillCountries();
  },

  methods: {
    setPerimeterAdmin: function() {
      if (this.perimeterAdmin == "all") {
        return [];
      } else {
        return this.perimeterAdmin.split(",");
      }
    },
    check: function() {
      return this.setPerimeterAdmin().includes(this.selectedCountry);
    },

    clearData: function() {
      this.listUsers = [];
    },

    setIcon: function(item) {
      if (
        this.perimeterAdmin == "all" ||
        this.setPerimeterAdmin().includes(item.workingCountry.code)
      ) {
        return true;
      } else {
        return false;
      }
    },
    exportAsCsv: function() {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      fetch(
        process.env.VUE_APP_ROOT_API_PATH +
          "api/users/export?name=" +
          this.findByName +
          "&active=" +
          this.selectedActive +
          "&top=" +
          this.selectedTop +
          "&country=" +
          this.selectedCountry,
        {
          method: "GET",
          credentials: "include",
          responseType: "blob",
        }
      )
        .then((response) => {
          return response.blob();
        })
        .then((blob) => {
          var url = window.URL.createObjectURL(blob);
          var a = document.createElement("a");
          a.href = url;
          a.download = "Export-users.csv";
          document.body.appendChild(a);
          a.click();
          a.remove();
        });
    },
    search: function() {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      fetch(
        process.env.VUE_APP_ROOT_API_PATH +
          "api/usersWithFilter?name=" +
          this.findByName +
          "&active=" +
          this.selectedActive +
          "&top=" +
          this.selectedTop +
          "&country=" +
          this.selectedCountry,
        {
          method: "GET",
          credentials: "include",
          headers: myHeaders,
        }
      )
        .then((response) => {
          if (response.status == "200" || response.status == "201") {
            this.message =
              "If your e-mail address is correct and known by the application,";
            this.message +=
              " an e-mail has been sent with insctructions to reset your password";
            this.messageType = "success";
            return response.json();
          } else {
            this.message = "An error happened, please try again later";
            this.messageType = "error";
          }
          this.showMessage = true;
        })
        .then((json) => {
          json.data.forEach((element) => {
            element.fullName =
              (element.firstName ? element.firstName : "") +
              " " +
              (element.lastName ? element.lastName : "");
            element.slm.fullName =
              (element.slm.firstName ? element.slm.firstName : "") +
              " " +
              (element.slm.lastName ? element.slm.lastName : "");
            element.dlm.fullName =
              (element.dlm.firstName ? element.dlm.firstName : "") +
              " " +
              (element.dlm.lastName ? element.dlm.lastName : "");
          });
          this.listUsers = json.data;
        })
        .catch(() => {
          this.message = "An error occurs, please try again later";
          this.messageType = "error";
          this.showMessage = true;
        });
    },
    fillCountries: function() {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      fetch(process.env.VUE_APP_ROOT_API_PATH + "api/ref/countries", {
        method: "GET",
        credentials: "include",
        headers: myHeaders,
      })
        .then((response) => {
          if (response.status == "200" || response.status == "201") {
            this.messageType = "success";
            return response.json();
          } else {
            this.message = "An error happened, please try again later";
            this.messageType = "error";
          }
          this.showMessage = true;
        })
        .then((json) => {
          this.refCountries = json.data;
          this.refCountries.push({
            code: "all",
            label: "",
          });
        })
        .catch(() => {
          this.message = "An error occurs, please try again later";
          this.messageType = "error";
          this.showMessage = true;
        });
    },
    addNew: function() {
      this.$router.push("/AdminUserAdd/");
    },
    updateEmployee: function(item) {
      this.$router.push({
        path: "/AdminUserUpdate/" + item.id,
      });
    },
  },
};
</script>
